import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionsEfolderDocumentDownloadFileFromDownloadUrlApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionDownloadFileFromDownloadUrl: builder.mutation({
				query: ({ downloadUrl, authorization }) => ({
					url: "/api/v1/loan/enhanced_condition_download_file_from_download_url/",
					method: "POST",
					body: {
						downloadUrl,
						authorization,
					},
					responseHandler: async (response) => {
						const contentType = response.headers.get("content-type") || "";

						if (contentType.includes("application/json")) {
							return response.json();
						}

						return response.blob();
					},
				}),
			}),
		}),
	});

export const {
	useEnhancedConditionDownloadFileFromDownloadUrlMutation,
} = fetchEnhancedConditionsEfolderDocumentDownloadFileFromDownloadUrlApiSlice;
